"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedDropdown = void 0;
var react_1 = __importDefault(require("react"));
var nestedMenuItemsFromObject_1 = require("./nestedMenuItemsFromObject");
var Button_1 = __importDefault(require("@mui/material/Button"));
var Menu_1 = __importDefault(require("@mui/material/Menu"));
var ChevronDown_1 = require("../icons/ChevronDown");
exports.NestedDropdown = react_1.default.forwardRef(function NestedDropdown(props, ref) {
    var _a = react_1.default.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var data = props.menuItemsData, onClick = props.onClick, ButtonProps = props.ButtonProps, MenuProps = props.MenuProps, rest = __rest(props, ["menuItemsData", "onClick", "ButtonProps", "MenuProps"]);
    var handleClick = function (e) {
        setAnchorEl(e.currentTarget);
        onClick && onClick(e);
    };
    var handleClose = function () { return setAnchorEl(null); };
    var menuItems = (0, nestedMenuItemsFromObject_1.nestedMenuItemsFromObject)({
        menuItemsData: data.items,
        isOpen: open,
        handleClose: handleClose,
    });
    return (react_1.default.createElement("div", __assign({ ref: ref }, rest),
        react_1.default.createElement(Button_1.default, __assign({ onClick: handleClick, endIcon: react_1.default.createElement(ChevronDown_1.ChevronDown, null) }, ButtonProps), data.label),
        react_1.default.createElement(Menu_1.default, __assign({ anchorEl: anchorEl, open: open, onClose: handleClose }, MenuProps), menuItems)));
});
